/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeadsIncomplete/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LeadsIncomplete({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Pie/CampaignOverview/Breakdown/LeadsIncomplete"
  
}) {
let marketingAnalyticsTotalIncompletesAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'marketing_analytics',
path: 'total_incompletes.aggregate.count',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="LeadsIncomplete.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="LeadsIncomplete.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="rgba(247,130,112,0.8)"
 size="large"
 marginRight={2}
 data="marketing_analytics.total_incompletes.aggregate.count"
 text={marketingAnalyticsTotalIncompletesAggregateCountValueData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text="Leads - Incomplete"
/>
</div>
{children}
</React.Fragment>)
}